<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">Register Machine</h3>
		</div>
	</div>
	<div class="kt-portlet__body">
		<div class="row justify-content-center">
			<mat-form-field class="col-md-4">
				<mat-label>Enter Serial Number</mat-label>
				<input matInput type="text" [(ngModel)]="serialNo"/>
				<mat-icon color="primary" (click)="check()" style="cursor: pointer" matSuffix>search</mat-icon>
			</mat-form-field>
			<!-- <button class="mb-3 ml-3 mr-3" mat-raised-button type="button" color="primary">
				check
			</button> -->
		</div>

		<div *ngIf="showFields" class="justify-content-center">
			<div class="row justify-content-center">
				<mat-form-field class="col-md-4">
					<mat-label>Enter Azkoyen Serial Number</mat-label>
					<input matInput type="text" [(ngModel)]="azSerialNo"/>
				</mat-form-field>
			</div>

			<div class="row justify-content-center">

				<mat-form-field class="col-md-4">
					<mat-label>Enter Screen Part Number</mat-label>
					<input matInput type="text" [(ngModel)]="screenPartNo"/>
				</mat-form-field>

			</div>

			<div class="row justify-content-center">
				<div class="col-md-4">
					<kt-hierarchical-filters
						role="sadmin"
						[showDistributor]="true"
						[showMarket]="false"
						[showClient]="false"
						[showCampus]="false"
						[multiple]="false"
						[initialValues]="initialFilterValues"
						(filterChange)="onFiltersChange($event)">
					</kt-hierarchical-filters>
				</div>
			</div>
		</div>

		<button *ngIf="showFields" class="col-md-1 mt-2 mx-auto text-center" (click)="onSubmited()" [disabled]="!distiName || !serialNo" mat-raised-button type="button" color="primary">
			Submit
		</button>
	</div>
</div>
